import React from 'react';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../../form';
import { RouteButton } from '../../../form/routeButton';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import { QuestionnaireList } from './QuestionnaireList';

export const QuestionnaireListPage: React.FC = () => {
  const { busy, errors, data } = useDataFetcher('/api/questionnaires');

  const questionnaires = data?.questionnaires || [];

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Questionnaires" subTitle="List" backPath="/admin" />
        <RouteButton className="mb-2" to="/admin/questionnaires/create">
          Create a new questionnaire
        </RouteButton>
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading questionnaires"
          errors={errors}
        >
          <QuestionnaireList questionnaires={questionnaires} />
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
